import { useCallback, useRef, useState } from "react";
import {
  downloadButtonDisabled,
  nextDownloadStatusOnError,
  nextDownloadStatusOnSuccess,
  type AttachmentDownloadStatus,
} from "./attachment-download-state.js";

export function useAttachmentDownload(): {
  status: AttachmentDownloadStatus;
  disabled: boolean;
  run: (task: () => Promise<void>) => Promise<void>;
} {
  const [status, setStatus] = useState<AttachmentDownloadStatus>("idle");
  const inFlightRef = useRef(false);

  const run = useCallback(async (task: () => Promise<void>) => {
    if (inFlightRef.current) {
      return;
    }
    inFlightRef.current = true;
    setStatus("downloading");
    try {
      await task();
      setStatus(nextDownloadStatusOnSuccess());
    } catch {
      setStatus(nextDownloadStatusOnError());
    } finally {
      inFlightRef.current = false;
    }
  }, []);

  return {
    status,
    disabled: downloadButtonDisabled(status),
    run,
  };
}
